import './App.css'
import { Switch, Route, Link } from 'react-router-dom'
import { CSSTransitionGroup } from 'react-transition-group'

import React, {Component, Fragment} from 'react'

class Main extends Component {
  render() {
    return (
      <div className="App-main App-flex-row main-buttons" >
        <Link className="subject-link" to="/FlashCards/math/Add/10">
          <div>
              Addition 10x10
          </div>
        </Link>
        <Link to="/FlashCards/math/Mult/10" className="subject-link">
          <div>
              Multiplication 10x10
          </div>
        </Link>
        <Link to="/FlashCards/math/Mult/12" className="subject-link">
          <div>
              Multiplication 12x12
          </div>
        </Link>
      </div>
    )
  }
}

export default Main



// WEBPACK FOOTER //
// ./src/Main.js